import { render, staticRenderFns } from "./DescriptionCreator.vue?vue&type=template&id=025669e4&scoped=true"
import script from "./DescriptionCreator.vue?vue&type=script&lang=js"
export * from "./DescriptionCreator.vue?vue&type=script&lang=js"
import style1 from "./DescriptionCreator.vue?vue&type=style&index=1&id=025669e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025669e4",
  null
  
)

export default component.exports